import { IonButton, IonInput, IonItem, IonLabel, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../../../../../../constants";
import { utilService } from "../../../../../../../../services";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import "./AddEditPatient.scss";
import { useToast } from "@agney/ir-toast";
import { statusBoardSocketService } from "../../../../../../StatusBoardSocketService";
import { EpicPatientDetailsForm } from "../../../../../../../../components/Shared/EpicPatientDetailsForm/EpicPatientDetailsForm";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  patientData: any;
  statusBoardData: any;
  onCancel: (data: boolean) => void;
}
const AddEditPatient: React.FC<ContainerProps> = (props) => {
  const [bed, setBed] = useState(props.patientData?.id);
  const [site, setSite] = useState(props.statusBoardData[0].site.siteId);
  const [unit, setUnit] = useState(props.statusBoardData[0].unit.unitId);
  const [sbId, setSbId] = useState(
    statusBoardService.statusBoardId ? statusBoardService.statusBoardId : ""
  );
  const [showSignInAlertForNote, setShowSignInAlertForNote] = useState(false);
  const [isFormValid, setFormStatus] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [userPassword, setUserPassword] = useState<string>("");
  const [isInvalidCredentials, setSignInValidations] = useState(false);
  const [fetchedRowData, setFetchedRowData] = useState<any>();
  const Toast = useToast();
  const { t } = useTranslation("statusBoard");

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  useEffect(() => {
    if (props.patientData?.pid !== " ") {
      getPatientDetails();
    }
  }, []);

  const getPatchData = (rowData: any) => {
    setFetchedRowData(rowData);
    setBed(rowData.bed_id ? rowData.bed_id : "");
    setSite(rowData.site_id ? rowData.site_id : "");
    setUnit(rowData.unit_id ? rowData.unit_id : "");
  };

  const getPatientDetails = async () => {
    const params = {
      pid: props.patientData?.pid,
      reg_code: utilService.getNetwork(),
    };
    const respResult: any = await statusBoardService.getPatientData(params);
    if (respResult.isSuccess && respResult.patientData.length) {
      getPatchData(respResult.patientData[0].data[0]);
    } else {
    }
  };

  const savePatientData = async () => {
    const date: any = new Date();
   const message =
  props.patientData?.pid === " "
    ? t("patientAddedSuccess")
    : t("patientUpdatedSuccess");
    const { fetchedResultData, formData } = fetchedPatientData;

    const params = {
      action_username: userName,
      action_password: userPassword,
      patient_name: `${formData?.firstName} ${formData?.middleName} ${formData?.lastName}`,
      display_name: formData?.firstName ?? "",
      first_name: formData?.firstName ?? "",
      middle_name: formData?.middleName ?? "",
      last_name: formData?.lastName ?? "",
      gender: formData?.gender[0] ?? "", // Eg:The data will be "Male" and in payload only needs M
      dob: formData?.dob ?? "",
      mr_number: formData?.mrn ?? "",
      ehr_id: fetchedResultData?.ehr_id ?? "",
      bed_id: bed,
      site_id: site,
      unit_id: unit,
      status_board_id: sbId,
      dnr: fetchedResultData?.dnr ?? "",
      email_addresses: fetchedResultData?.email_addresses ?? "",
      phone_number: fetchedResultData?.phone_number ?? {},
      demographic: fetchedResultData?.demographic ?? {},
      datetime: utilService.getFullDate(date),
      reg_code: utilService.getNetwork(),
      patient_id:
        props.patientData?.pid === " " ? undefined : props.patientData?.pid,
      ehr_bed_id: fetchedResultData?.ehr_bed_id ?? "",
      ehr_bed_name: fetchedResultData?.ehr_bed_name ?? "",
      ehr_unit_id: fetchedResultData?.ehr_unit_id ?? "",
      ehr_unit_name: fetchedResultData?.ehr_unit_name ?? "",
      primary_ehr_site_id: fetchedResultData?.primary_ehr_site_id ?? "",
      primary_ehr_site_name: fetchedResultData?.primary_ehr_site_name ?? "",
      profile_id:fetchedResultData?.profile_id ?? "",
      record_id:fetchedResultData?.record_id ?? "",
    };
    const respResult: any = await statusBoardService.addPatientData(params);

    if (respResult.isSuccess) {
      closePopup(true);
      Toast.success(message);
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.ADD_EDIT_PATIENT,
        bedId: props.patientData?.id,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
    } else {
      if(!respResult?.result?.is_valid_credentials){
        setSignInValidations(true);
      }else{
        Toast.error(respResult.message);
      }
    }
  };

  const closePopup = (status: boolean) => {
    props.onCancel(status);
  };

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  const closeModal = () => {
    closePopup(false);
  };

  const [fetchedPatientData, setFetchedPatientData] = useState<any>();

  const handleEPICFormSave = (patientData: any) => {
    setShowSignInAlertForNote(true);
    setFetchedPatientData(patientData);
  };

  return (
    <>
      <EpicPatientDetailsForm
        handleSaveButton={handleEPICFormSave}
        isOpen={props.showModal}
        onCancel={closeModal}
      title={
  props.patientData?.pid === " "
    ? t("admitPatient")
    : t("editPatient")
}
        isSelectCaseType={false}
        rowData={fetchedRowData}
        isEMTUser={false}
      />
      <IonModal
        isOpen={showSignInAlertForNote}
        backdropDismiss={false}
        className="add-fav-modal sign-In-modal"
      >
        <div className="label-div">
         <div className="label-name">{t("signIn")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlertForNote(false);
              setUserName("");
              setUserPassword("");
              setSignInValidations(false);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                <IonLabel position="floating">{t("username")}</IonLabel>
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                <IonLabel position="floating">{t("password")}</IonLabel>
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
           {t("invalidCredentials")}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              <IonButton>{t("clear")}</IonButton>
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                savePatientData();
              }}
            >
{t("signIn")}</IonButton>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default AddEditPatient;
